import { DataBean } from "../DataBean";

export class OfficialBook extends DataBean {



    public async getOfficialBookCatalog(idCompany:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getOfficialBookCatalog_Number", [idCompany]);
    }

     public async updateOfficialBook(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.OfficialBook_updateOfficialBook_com.quickdataerp.bean.accountant.OfficialBook", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.accountant.OfficialBook"
            }
        ]);
    }
}